<template>
  <div class="app-container">
    <el-container>
      <el-aside width="200px">
        <div class="head-container">
          <el-tree
            class="role-tree"
            :data="roleList"
            :props="roleProps"
            node-key="id"
            :expand-on-click-node="true"
             ref="tree"
            :highlight-current="true"
            @node-click="handleNodeClick"
          />
        </div>
      </el-aside>
      <el-main>
        <el-form>
          <el-form-item>
            <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event)">展开/折叠</el-checkbox>
            <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event)">全选/全不选</el-checkbox>
            <el-checkbox v-model="menuCheckStrictly" @change="handleCheckedTreeConnect($event)">父子联动</el-checkbox>
            <el-button type="primary" @click="onSubmit" style="float:right">保存</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText">
            </el-input>
            <el-tree
              :data="menuOptions"
              show-checkbox
              ref="menu"
              node-key="id"
              :check-strictly="!menuCheckStrictly"
              :filter-node-method="filterNode"
              empty-text="加载中，请稍候"
              :props="defaultProps"
              class="role-menu-tree"
            ></el-tree>
          </el-form-item>
        </el-form>
          
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { listRoleTemplate , moduleTreeSelect , updateTemplate , roleTemplateMenuIds} from "@/api/api";

export default {
  name: "roleTemplate",
  data() {
    return {
      roleProps:{
        children: "children",
        label: "name"
      },
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [],
      menuExpand: false,
      menuNodeAll: false,
      menuCheckStrictly: true,
      defaultProps: {
        children: "children",
        label: "label"
      },
      filterText: '',
      // 菜单列表
      menuOptions: [],
      moduleIds:[],
      roleType:'',
    };
  },
  watch:{
    filterText(param){
      this.$refs.menu.filter(param);
    } 
  },
  created() {
    this.getList();
    this.getModuleTreeselect();
  },
  methods: {
    /** 查询角色列表 */
    getList() {
      this.loading = true;
      let params = {
        model:{},
        page: 1,
        pageSize: 20,
      };
      listRoleTemplate(params).then(res => {
          this.roleList = res.data.data.records;
          this.loading = false;
          const firstNode = this.roleList[0];
          if (firstNode) {
            this.currentId = firstNode.id
            this.roleType = firstNode.roleType
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(firstNode.id)
              this.$refs.menu.setCheckedKeys(firstNode.menuIds);
            })
          }
        }
      );
    },
    /** 查询菜单树结构 */
    getModuleTreeselect() {
      moduleTreeSelect().then(res => {
        this.menuOptions = res.data.data;
      });
    },
    handleCheckedTreeExpand(value) {
      let treeList = this.menuOptions;
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      this.$refs.menu.setCheckedNodes(value ? this.menuOptions: []);
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value) {
      this.menuCheckStrictly = value ? true: false;
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //左侧数据点击
    handleNodeClick(data){
      this.roleType = data.roleType
      let type = this.roleType 
      this.$refs.menu.setCheckedKeys([]);
      roleTemplateMenuIds({type}).then(res=>{
        res.data.data.forEach(item=>{
          this.$nextTick(()=>{
              this.$refs.menu.setChecked(item, true ,false);
          })
        })
      })
      
    },
    onSubmit(){
       this.moduleIds = this.getMenuAllCheckedKeys();
       updateTemplate({roleType:this.roleType ,menuIds:this.moduleIds}).then(res=>{
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 1500
        });
       })
    }
  }
};
</script>
<style scoped lang="less">

.el-aside {
  background-color: #fff;
  color: #333;
  border: 1px solid #eef1f6;
  padding: 0px 0px;
  ::v-deep .el-tree-node__content {
      height: 50px;
      line-height: 50px;
  }
  ::v-deep .el-tree .is-current, .el-tree-node__content {
    color: #1890ff !important; 
  }
}
.el-main{
  padding: 0px 20px;
  .role-menu-tree{
      height: calc(100vh - 240px);
      z-index: 1024;
      overflow: auto;
  }
}

</style>